import { currentLang, formatShortDate } from '@utils/dateUtils';
import { FlagOutlineIcon } from '@utils/icons';

interface IDueDayProps {
  /** YYYY-MM-DD. */
  day: string;
  /** The site's zone. */
  tz: string;
}

/** Trusstor's flag + short date — a list card's due tag and a chip card's due line. */
export function DueDay({ day, tz }: IDueDayProps) {
  return (
    <>
      <FlagOutlineIcon size={14} />
      {formatShortDate(day, currentLang(), tz)}
    </>
  );
}
